import { render, staticRenderFns } from "./PracticeInformationForm.vue?vue&type=template&id=174498d0"
import script from "./PracticeInformationForm.vue?vue&type=script&lang=js"
export * from "./PracticeInformationForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports